/**
 * Created by: cparaschiv
 * Date: 17.05.2013, 17:32
 */


(function () {
    'use strict';

    var CHANGE = 'change';

    TS.LazyDataSource = kendo.data.DataSource.extend({

        Extends: kendo.data.DataSource,

        isLoaded: false,

        init: function (options) {
            var me = this;

            kendo.data.DataSource.fn.init.call(me, options);

            me.bind('error', me._onError);
            if (!( me.transport instanceof TS.LazyTransport))
                me.transport = new TS.LazyTransport(options.transport);
        },

        fetch: function (callback) {
            var me = this;
            if (callback && typeof callback === 'function') {
                me.one(CHANGE, callback);
            }

            return me._query();
        },

        _onError: function (e) {
            var notif;

            TS.Log.error('Error loading data: ' + (e.errorThrown || '?'));
            if (e.xhr && e.xhr.success === false && e.xhr.messages) {
                notif = TS.Util.getNotifications(e.xhr);
            }
            TS.Notify.error(TS.cultures.current.error.LoadError + '<br>' + (notif ? notif.errors : (e.errorThrown || '')));
        }

    });

})();
